import App from '@/commons/modules/app/App';

export default new App(process.env.TENANT_CARRIER ?? 'undefined');
